import styled from 'styled-components'
import KmHesaplamaRouteSide from '../../components/kmHesaplama/KmHesaplamaRouteSide'
import KmHesaplamaMapSide from '../../components/kmHesaplama/KmHesaplamaMapSide'
import { useSelector, useDispatch } from 'react-redux'
import { resetKmState } from '../../features/kmCalc/kmCalcSlice'
import { useEffect } from 'react'

const Container = styled.div`
  display: flex;
  justify-content: space-between;
  color: ${({theme}) => theme.mainTextColor};
  width: 100% !important;

  @media (max-width: 1100px) {
    flex-direction: column-reverse;
  }
`

const KmHesaplama = () => {

  const {route} = useSelector(state => state.kmCalc)
  const dispatch = useDispatch()

  useEffect(() => {
   
    return ()=> {
      dispatch(resetKmState())
    }
  },[])

  return (
    <Container>
      <KmHesaplamaRouteSide/>
      <KmHesaplamaMapSide/>
    </Container>
  )
}

export default KmHesaplama